import { GetCategoryTopicListParams } from "repositories/CategoryTopicRepository";
import { repository } from "repositories";
import {
  GetCategoryTopicListRes,
  SWRResponse,
  WithPaginationMetaResponse,
} from "shared/types";
import useSWR from "swr";

export const useCategoryTopicList = (
  alias: string | string[],
  params: GetCategoryTopicListParams
): SWRResponse<
  WithPaginationMetaResponse<Omit<GetCategoryTopicListRes, "meta">>
> => {
  const repo = repository.categoryTopic.getList(alias, params);
  const { data, error, mutate } = useSWR(repo.path, repo.data, {
    fallbackData: { topics: [], meta: { totalPages: 1, totalCounts: 0 } },
  });

  return {
    ...data,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};
